// A threshold of 0.0 requires a perfect match, a threshold of 1.0 would match anything.
// The default for Fuse is 0.6, but that's a bit too high for most of our use cases
export const defaultThreshold = 0.3;
